import styled from "styled-components";

export const StyledFileInputWrapper = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 20px 30px;
  grid-gap: 10px;
  .file-desc {
    color: rgba(0, 0, 0, 0.54);
  }
  .added-file {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      max-width: 250px;
      width: 100%;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  label {
    width: 30px;
    height: 30px;
    color: #277661;
    border: 2px solid #277661;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    transition: all .3s ease;
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
    &:active {
      transform: translateY(2px);
    }
  }
  input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    visibility: hidden;
  }
`;